export const PAYMENT_METHODS = {
    ADYEN_COMPONENT: 'AdyenComponent',
    CREDIT_CARD: 'CREDIT_CARD',
    GIFT_CERTIFICATE: 'GIFT_CERTIFICATE',
    BOLT_PAY: 'BOLT_PAY'
}

export const PAYMENT_METHOD_TYPES = {
    GIFT_CARD: 'giftcard',
    KLARNA: 'klarna',
    KLARNA_ACCOUNT: 'klarna_account',
    WECHATPAY_MINI_PROGRAM: 'wechatpayMiniProgram',
    WECHATPAY_QR: 'wechatpayQR',
    WECHATPAY_SDK: 'wechatpaySDK'
}

export const RESULT_CODES = {
    AUTHORISED: 'Authorised',
    CANCELLED: 'Cancelled',
    CHALLENGESHOPPER: 'ChallengeShopper',
    ERROR: 'Error',
    IDENTIFYSHOPPER: 'IdentifyShopper',
    PENDING: 'Pending',
    PRESENTTOSHOPPER: 'PresentToShopper',
    RECEIVED: 'Received',
    REDIRECTSHOPPER: 'RedirectShopper',
    REFUSED: 'Refused'
}

export const BLOCKED_PAYMENT_METHODS = [
    PAYMENT_METHOD_TYPES.GIFT_CARD,
    PAYMENT_METHOD_TYPES.WECHATPAY_MINI_PROGRAM,
    PAYMENT_METHOD_TYPES.WECHATPAY_QR,
    PAYMENT_METHOD_TYPES.WECHATPAY_SDK
]

export const SHOPPER_INTERACTIONS = {
    CONT_AUTH: 'ContAuth',
    ECOMMERCE: 'Ecommerce'
}

export const RECURRING_PROCESSING_MODEL = {
    CARD_ON_FILE: 'CardOnFile'
}

export const ORDER = Object.freeze({
    ORDER_STATUS_CREATED: 'created',
    ORDER_STATUS_NEW: 'new',
    ORDER_STATUS_COMPLETED: 'completed',
    ORDER_STATUS_CANCELED: 'cancelled',
    ORDER_STATUS_FAILED: 'failed',
    ORDER_STATUS_FAILED_REOPEN: 'failed_with_reopen',
    PAYMENT_STATUS_PAID: 'paid',
    PAYMENT_STATUS_PART_PAID: 'part_paid',
    PAYMENT_STATUS_NOT_PAID: 'not_paid',
    EXPORT_STATUS_READY: 'ready',
    EXPORT_STATUS_FAILED: 'failed',
    EXPORT_STATUS_EXPORTED: 'exported',
    EXPORT_STATUS_NOT_EXPORTED: 'not_exported',
    CONFIRMATION_STATUS_CONFIRMED: 'confirmed',
    CONFIRMATION_STATUS_NOT_CONFIRMED: 'not_confirmed'
})

export const ADYEN_LIVE_REGIONS = {
    LIVE_EU: 'live',
    LIVE_APSE: 'live-apse',
    LIVE_AU: 'live-au',
    LIVE_US: 'live-us',
    LIVE_IN: 'live-in'
}

export const ADYEN_ENVIRONMENT = {
    LIVE: 'LIVE',
    TEST: 'TEST'
}

export const ERROR_MESSAGE = {
    AMOUNT_NOT_CORRECT: 'amount not correct',
    INVALID_ORDER: 'order is invalid',
    INVALID_PARAMS: 'invalid request params',
    INVALID_BASKET: 'invalid basket',
    BASKET_NOT_CREATED: 'basket not created',
    PAYMENT_NOT_SUCCESSFUL: 'payment was not successful',
    INVALID_BILLING_ADDRESS: 'invalid billing address',
    INVALID_SHIPPING_ADDRESS: 'invalid shipping address',
    UNAUTHORIZED: 'unauthorized',
    ORDER_ALREADY_EXISTS: 'order already exists',
    ORDER_NOT_FOUND: 'order not found',
    ORDER_NUMBER_NOT_FOUND: 'order number not found on basket',
    PAYMENTS_DETAILS_NOT_SUCCESSFUL: 'payments details call not successful',
    BASKET_CHANGED: 'basket changed',
    AMOUNTS_DONT_MATCH: 'amounts do not match',
    MISSING_LIVE_PREFIX: 'missing live prefix',
    ADYEN_CONTEXT_NOT_FOUND: 'Adyen context not found',
    NO_PAYMENT_METHODS: 'no payment methods',
    ADD_PAYMENT_INSTRUMENTS: 'Failed to add payment instrument due to missing parameters',
    CUSTOMER_NOT_FOUND: 'customer not found',
    BASKET_NOT_FOUND: 'Basket not found in adyenContext',
    PSP_REFERENCE_NOT_FOUND: 'PSP reference not found in basket',
    INVALID_PAYMENT_DATA: 'Invalid payment data',
    PAYMENT_INSTRUMENT_NOT_FOUND: 'Payment instrument not found',
    DONATION_NOT_COMPLETED: 'Donation unsuccessful',
    DONATION_CAMPAIGN_NOT_FOUND: 'Donation campaign not found',
    DONATION_AMOUNT_MISMATCH: 'Donation amount now allowed',
    NO_BALANCE_GIFT_CERT:
        'The gift card you have entered has a balance of $0.00 and is unable to be applied to this order.',
    MAX_REACHED_GIFT_CERT: 'Too many gift cards were used as payment method already.',
    NOT_ALLOWED_GIFT_CERT:
        "You can't pay for an order containing gift cards with other gift cards.",
    ALREADY_EXIST_GIFT_CERT: 'The specified card number is already present in this order.',
    SERVER_ISSUE: `Application is not initialized. Please ensure '_createApp' has been invoked before using this method.`
}

export const APPLICATION_VERSION = '3.0.3'

export const BOLT = {
    CC_MASKED_DIGITS: 'XXXX-XXXX-XXXX-',
    PAYMENT_METHOD_CARD: 'card',
    OAUTH_TOKEN_REFRESH_TIME: 4000,
    SOURCE_NAME: 'commerce_cloud',
    SOURCE_VERSION: '23.5.1',
    DIRECT_PAYMENTS: 'direct_payments',
    TOKEN_TYPE: 'bolt'
}
